import { useCallback, useContext } from 'react';
import get from 'lodash/get';
import { I18nContext } from '~/context/I18nProvider';

export default function useTranslation() {
  const { localeData } = useContext(I18nContext);

  const getTranslation = useCallback((
    key: string,
    data: { [key: string]: string | number } = {},
  ) => {
    let translatedText = get(localeData, key) ?? key;

    Object.keys(data).forEach((dataKey) => {
      translatedText = translatedText.replace(`:${dataKey}`, data[dataKey].toString());
    });

    return translatedText;
  }, [localeData]);

  return getTranslation;
}
